export default __webpack_public_path__ + "static/media/recycle-min.852b0233.svg";